const STORAGE_KEY = "oval_coach_auth_v1";

const listeners = new Set();

const isBrowser = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const normalizeSession = (value) => {
  if (!value || typeof value !== "object") return null;
  const token = String(value.token || "").trim();
  const user = value.user && typeof value.user === "object" ? value.user : null;
  if (!token || !user?.id || user?.role !== "coach") return null;
  return {
    token,
    user,
  };
};

const readStoredSession = () => {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return normalizeSession(JSON.parse(raw));
  } catch {
    return null;
  }
};

let currentSession = readStoredSession();

const emitChange = () => {
  listeners.forEach((listener) => {
    try {
      listener(currentSession);
    } catch {
      // noop
    }
  });
};

export const getStoredCoachSession = () => currentSession;

export const getStoredCoach = () => currentSession?.user || null;

export const getAuthToken = () => currentSession?.token || "";

export const setStoredCoachSession = (value) => {
  currentSession = normalizeSession(value);
  if (isBrowser()) {
    if (currentSession) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(currentSession));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }
  emitChange();
};

export const clearStoredCoachSession = () => {
  setStoredCoachSession(null);
};

export const subscribeCoachSession = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
